import { useEffect } from 'react';

const ICONS = [
  { rel: 'icon', type: 'image/png', sizes: '32x32', file: 'lawyah-icon-32.png', testId: 'lawyah-favicon-png' },
  { rel: 'icon', type: 'image/svg+xml', sizes: 'any', file: 'lawyah-icon.svg', testId: 'lawyah-favicon-svg' },
  { rel: 'apple-touch-icon', type: 'image/png', sizes: '180x180', file: 'lawyah-touch-icon.png', testId: 'lawyah-touch-icon' },
];

export const BrowserBranding = () => {
  useEffect(() => {
    // Also replaces old tab branding when a browser reuses a previously served HTML shell.
    document.head.querySelectorAll('link[rel~="icon"], link[rel="apple-touch-icon"]').forEach(link => link.remove());
    const links = ICONS.map(icon => {
      const link = document.createElement('link');
      link.rel = icon.rel; link.type = icon.type; link.setAttribute('sizes', icon.sizes);
      link.href = `${process.env.PUBLIC_URL}/${icon.file}?v=2`;
      link.dataset.testid = icon.testId;
      document.head.appendChild(link);
      return link;
    });
    return () => links.forEach(link => link.remove());
  }, []);
  return null;
};